import { isValid } from './state/info.mjs';
export { getInfo, setInfo } from './state/info.mjs';
import '../constants/runtime.mjs';
export { originals } from './state/originals.mjs';

function isConfigured(agentIdentifier) {
  return isValid(agentIdentifier);
}

export { isConfigured };
//# sourceMappingURL=config.mjs.map
